import { hasPersonData } from './mapIssuanceForApi';

const mapPersonForApi = (person) => {
  if (!person || !hasPersonData(person)) {
    return undefined;
  }

  return {
    IdentificationType: person.identificationType,
    Identification: person.identification,
    Name: person.name,
    LastName: person.lastName,
    BirthDate: person.birthDate,
    BirthPlace: person.birthPlace,
    Gender: person.gender,
    Nacionality: person.nacionality,
    Height: person.height != null && person.height !== '' ? Number(person.height) : undefined,
    Weight: person.weight != null && person.weight !== '' ? Number(person.weight) : undefined,
    IsIncapacitated: person.isIncapacitated ?? false,
    IsValidatedCivilRegistry: person.isValidatedCivilRegistry ?? true,
    QuestionCovid19TestPerformed: person.questionCovid19TestPerformed,
    QuestionCovid19ResultPositive: person.questionCovid19ResultPositive,
    MedicalConditions: person.medicalConditions,
    RelationshipBeneficiary: person.relationshipBeneficiary,
  };
};

const mapDependantForApi = (dependant) => {
  const mapped = mapPersonForApi(dependant);
  if (!mapped) {
    return undefined;
  }
  return {
    ...mapped,
    RelationshipBeneficiary: dependant.relationshipBeneficiary,
  };
};

/**
 * Mapea el personalData del formulario (camelCase) al contrato .NET (PascalCase).
 * InsuranceHolder solo aplica cuando withDifferentHolder es true (Infinity Kids).
 */
export default function mapPersonalDataForApi(formData, { withDifferentHolder = false } = {}) {
  if (!formData) {
    return undefined;
  }

  const insuranceMainInsured = mapPersonForApi(formData.insuranceMainInsured);
  const insuranceHolder = withDifferentHolder
    ? mapPersonForApi(formData.insuranceHolder)
    : undefined;
  const insuranceDependants = formData.insuranceDependants
    ?.map(mapDependantForApi)
    .filter(Boolean);

  if (!insuranceMainInsured && !insuranceHolder && !insuranceDependants?.length) {
    return undefined;
  }

  const personalData = {
    InsuranceMainInsured: insuranceMainInsured,
  };

  if (insuranceHolder) {
    personalData.InsuranceHolder = insuranceHolder;
  }

  if (insuranceDependants?.length) {
    personalData.InsuranceDependants = insuranceDependants;
  }

  return personalData;
}
